import HeroSection from "./components/HeroSection";
import ServicesOverview from "./components/ServicesOverview";
import TrustBar from "../../components/feature/TrustBar";
import AIAnswerBlock from "../../components/feature/AIAnswerBlock";
import ProcessSection from "../../components/feature/ProcessSection";
import WhyChooseUs from "../../components/feature/WhyChooseUs";
import ServiceAreasSection from "../../components/feature/ServiceAreasSection";
import Testimonials from "../../components/feature/Testimonials";
import FAQSection from "../../components/feature/FAQSection";
import FinalCTA from "../../components/feature/FinalCTA";

export default function HomePage() {
  return (
    <main>
      {/* 1. Hero */}
      <HeroSection />

      {/* 2. Trust Bar */}
      <TrustBar />

      {/* 3. Services Overview */}
      <ServicesOverview />

      {/* 4. AI Answer Block */}
      <AIAnswerBlock />

      {/* 5. Process */}
      <ProcessSection />

      {/* 6. Why Choose Us */}
      <WhyChooseUs />

      {/* 7. Service Areas */}
      <ServiceAreasSection />

      {/* 8. Testimonials */}
      <Testimonials />

      {/* 9. FAQ – Voice Search */}
      <FAQSection />

      {/* 10. Final CTA */}
      <FinalCTA />
    </main>
  );
}
